export const ENV_DEVELOPMENT = "development";
export const ENV_STAGING = "staging";
export const ENV_PRODUCTION = "production";